var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtaTopSwirlMobileinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 708 92.6",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#103559",
    d: "M710 11.9v24C675.6 19 576.9-6.9 457.9 24.3 309.2 63.2 160.2 57.5 90.6 35.8 34.9 18.5 6.5 4.6-.7-.2v-2.4c-.8-.5-1.7-.9-2.5-1.4v381.6l713.4-1.3.5-363.9c-.2-.2-.4-.4-.7-.5z"
  })));
}
export default SvgCtaTopSwirlMobileinline;